

export function Image(data: any) {
  return <><img src={ data?.record?.value} /></>;
}